import { Types } from "../actions/MasterDataActions";

const initialState = {
    excelList: [],
    excelToListResponse: {},
    uploadExcelFileResponse: {},
};

export const MasterDataReducers = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_MASTER_DATA_EXCEL_JSON:
            return {
                ...state,
                excelToListResponse: action.payload || state.excelToListResponse,
            };
        case Types.UPLOAD_EXCEL_FILE_RESPONSE:
            return {
                ...state,
                uploadExcelFileResponse: action.payload || state.uploadExcelFileResponse,
            };
        default:
            return state;
    }
};
